<template>
    <div class="input-container">
        <label>
            <input v-model="value"
                   :name="name"
                   :type="dataType"
                   autocomplete="off"
                   @focus="customFocus"
                   @blur="isEdited = true"
                   @input="isEdited = true"
            />
            <span :class="{incorrect: validate && isEdited, beforeVisit : !isVisited}"
                  class="custom_placeholder"
                  v-html="placeholder">
            </span>
        </label>
        <transition name="fade">
             <span class="error-display"
                   v-if="validate && isEdited"
                   v-html="errorMsg">
        </span>
        </transition>

    </div>
</template>

<script>
    export default {
        name: "InputsCustomQuestion",
        props: ['placeholder', 'dataType', 'regex', 'require', 'name', 'errorMsg'],
        data() {
            return {
                value: '',
                isVisited: false,
                isIncorect: false,
                isEdited: false,
                type: ''
            }
        },
        methods: {
            customFocus() {
                this.isVisited = true;
            },

            emitValidateData() {
                this.customFocus();
                this.isEdited = true;
                this.$parent.$emit('validateData', {
                    inputName: this.name,
                    isIncorect: this.validate,
                    value: this.validate ? false : this.value,
                });
            },
        },

        computed: {
            validate() {
                if (this.require) {
                    if (this.regex) {
                        return !this.regex.test(this.value);
                    } else {
                        return this.value === '';
                    }
                } else {
                    return false
                }
            },
        },

        mounted() {
            this.$parent.$on('getValidateData', () => {
                this.emitValidateData();
            });
        }
    }
</script>

<style scoped lang="scss">
    .fade-enter-active, .fade-leave-active {
        transition: all 0.3s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
        transform: scale(0);
    }
</style>